import BadgeCheck from "@/assets/icons/badgeCheck.svg?react";
import Chat from "@/assets/icons/chat.svg?react";
import Chats from "@/assets/icons/chats.svg?react";
import ChevronDown from "@/assets/icons/chevronDown.svg?react";
import ChevronUp from "@/assets/icons/chevronUp.svg?react";
import Circle from "@/assets/icons/circle.svg?react";
import CircleDollar from "@/assets/icons/circleDollar.svg?react";
import CircleFill from "@/assets/icons/circleFill.svg?react";
import Dashboard from "@/assets/icons/dashboard.svg?react";
import DoubleCheckIcon from "@/assets/icons/doubleCheck.svg?react";
import ExternalLink from "@/assets/icons/externalLink.svg?react";
import Filter from "@/assets/icons/filter.svg?react";
import Bold from "@/assets/icons/form/bold.svg?react";
import ImageManager from "@/assets/icons/form/imageManager.svg?react";
import InsertLink from "@/assets/icons/form/insertLink.svg?react";
import Italic from "@/assets/icons/form/italic.svg?react";
import StrikeThrough from "@/assets/icons/form/strikeThrough.svg?react";
import Underline from "@/assets/icons/form/underline.svg?react";
import Graphics from "@/assets/icons/graphics.svg?react";
import Lock from "@/assets/icons/lock.svg?react";
import Logout from "@/assets/icons/logout.svg?react";
import Mail from "@/assets/icons/mail.svg?react";
import Menu from "@/assets/icons/menu.svg?react";
import Message from "@/assets/icons/message.svg?react";
import Pause from "@/assets/icons/pause.svg?react";
import Person from "@/assets/icons/person.svg?react";
import Phone from "@/assets/icons/phone.svg?react";
import Play from "@/assets/icons/play.svg?react";
import Plus from "@/assets/icons/plus.svg?react";
import Search from "@/assets/icons/search.svg?react";
import Send from "@/assets/icons/send.svg?react";
import Settings from "@/assets/icons/settings.svg?react";
import Trash from "@/assets/icons/trash.svg?react";
import WhatsappSettings from "@/assets/icons/whatsappSettings.svg?react";
import X from "@/assets/icons/x.svg?react";
import { File, PhoneCall, Smartphone, User } from "lucide-react";

export type IconType =
  | "dashboard"
  | "person"
  | "filter"
  | "mail"
  | "message"
  | "phone"
  | "phoneCall"
  | "smartphone"
  | "search"
  | "settings"
  | "whatsappSettings"
  | "chevronUp"
  | "chevronDown"
  | "bold"
  | "imageManager"
  | "insertLink"
  | "italic"
  | "strikeThrough"
  | "underline"
  | "plus"
  | "trash"
  | "circle"
  | "circleFill"
  | "menu"
  | "circleDollar"
  | "chats"
  | "graphics"
  | "x"
  | "lock"
  | "chat"
  | "externalLink"
  | "play"
  | "pause"
  | "send"
  | "logout"
  | "badgeCheck"
  | "user"
  | "file"
  | "doubleCheck";

type IconProps = React.HTMLAttributes<HTMLDivElement> & {
  icon: IconType;
  className?: string;
};

const icons: Record<IconType, React.FC<React.SVGProps<SVGSVGElement>>> = {
  dashboard: Dashboard,
  filter: Filter,
  mail: Mail,
  message: Message,
  person: Person,
  phone: Phone,
  phoneCall: PhoneCall,
  smartphone: Smartphone,
  search: Search,
  settings: Settings,
  whatsappSettings: WhatsappSettings,
  chevronUp: ChevronUp,
  chevronDown: ChevronDown,
  bold: Bold,
  imageManager: ImageManager,
  insertLink: InsertLink,
  italic: Italic,
  strikeThrough: StrikeThrough,
  underline: Underline,
  plus: Plus,
  trash: Trash,
  circle: Circle,
  circleFill: CircleFill,
  menu: Menu,
  circleDollar: CircleDollar,
  chats: Chats,
  graphics: Graphics,
  x: X,
  lock: Lock,
  chat: Chat,
  send: Send,
  externalLink: ExternalLink,
  play: Play,
  pause: Pause,
  logout: Logout,
  badgeCheck: BadgeCheck,
  doubleCheck: DoubleCheckIcon,
  user: User,
  file: File
};

export const Icon = ({ icon, className, ...props }: IconProps) => {
  const SvgIcon = icons[icon];

  return (
    <div {...props}>
      <SvgIcon className={className} />
    </div>
  );
};
